var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "five-stars-histogram",
      class: {
        vertical: _vm.vertical,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "five-stars-histogram-average",
        },
        [
          _c(
            "p",
            {
              staticClass: "fraction",
            },
            [
              _c(
                "span",
                {
                  staticClass: "average",
                },
                [_vm._v(_vm._s(_vm.average.toFixed(1)))]
              ),
              _vm._v("/5\n        "),
            ]
          ),
          _vm._v(" "),
          _c("studip-five-stars", {
            attrs: {
              amount: _vm.average,
            },
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "total",
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$gettextInterpolate(
                      _vm.$ngettext(
                        "%{n} Bewertung",
                        "%{n} Bewertungen",
                        _vm.entries.length
                      ),
                      {
                        n: _vm.entries.length,
                      }
                    )
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.ratings
        ? _c(
            "div",
            {
              staticClass: "five-stars-histogram-chart",
            },
            _vm._l([5, 4, 3, 2, 1], function (i) {
              var _vm$ratings$i
              return _c(
                "div",
                {
                  key: "chart-" + i,
                },
                [
                  _c(
                    "span",
                    [
                      _vm._v(_vm._s(i) + " "),
                      _c("studip-icon", {
                        attrs: {
                          shape: "star",
                          role: "info",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "percentage",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "percentage-bar",
                          style: {
                            width: _vm.getRatePercentage(_vm.ratings[i]),
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getRatePercentage(_vm.ratings[i])) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        (_vm$ratings$i = _vm.ratings[i]) !== null &&
                          _vm$ratings$i !== void 0
                          ? _vm$ratings$i
                          : 0
                      )
                    ),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }